import type { ReactNode } from "react";
import type { Optional } from "../../types";
import { AccordionBody } from "./accordion-body.component";
import { AccordionHeader } from "./accordion-header.component";
import { AccordionItemWithProvider } from "./accordion-item.component";
import { AccordionProvider } from "./providers";

export type AccordionProps = {
  children: ReactNode;
  isSingle?: Optional<boolean>;
};

export function Accordion({ children, isSingle, ...props }: AccordionProps) {
  return (
    <AccordionProvider isSingle={isSingle ?? false} {...props}>
      {children}
    </AccordionProvider>
  );
}

export namespace Accordion {
  export const Item = AccordionItemWithProvider;
  export const Header = AccordionHeader;
  export const Body = AccordionBody;
}
